/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useNavigate } from 'react-router-dom';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { useStartupState } from '../../Providers/StartupState';
import { baseUrlImg } from '../../Api';
import { atualizarLayout, layoutGuardado } from '../../Api/layout';
import { useFaseDoCarregamento } from '../Loading';
import * as S from './style';

export const Footer = () => {
  const { menu } = useHeaderStates();
  // Nasce com a última versão vista (ou a embutida) e se atualiza com o
  // Squidex. Não mexe no "carregando" das páginas (ver Providers/HeaderStates).
  const [data, setData] = useState(() => layoutGuardado('footer'));
  const navigate = useNavigate();
  const faseDoCarregamento = useFaseDoCarregamento();

  const { token } = useStartupState();

  useEffect(() => {
    if (!token) return;
    atualizarLayout(token, 'footer')
      .then(setData)
      .catch((e) => console.log('rodapé:', e.message));
  }, [token]);

  const handleScrollTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!data) return null;

  return (
    <S.FooterBox>
      {/* Some enquanto a página carrega: não há o que rolar. */}
      {faseDoCarregamento === 'pronto' && (
        <S.TopPage
          type="button"
          aria-label="Voltar ao início da página"
          title="Voltar ao topo"
          onClick={handleScrollTop}
        >
          <KeyboardArrowUpIcon />
        </S.TopPage>
      )}

      <S.FooterContainer>
        <S.FooterGrid>
          {/* Coluna 1: Marca, Contato Direto e Redes Sociais */}
          <S.BrandColumn>
            <S.BrandInfoWrapper>
              {data?.logo?.[0] && (
                <S.BrandLogo onClick={() => navigate('/')} title="Copasul">
                  <img
                    src={`${baseUrlImg}${data.logo[0]}`}
                    alt="Logo Copasul"
                  />
                </S.BrandLogo>
              )}

              <S.ContactList>
                {data?.informacoes?.[0]?.endereco && (
                  <S.ContactItem>
                    <LocationOnIcon />
                    <span>{data.informacoes[0].endereco}</span>
                  </S.ContactItem>
                )}

                {data?.informacoes?.[0]?.email && (
                  <S.ContactItemLink
                    href={`mailto:${data.informacoes[0].email}`}
                    title="Enviar e-mail"
                  >
                    <EmailIcon />
                    <span>{data.informacoes[0].email}</span>
                  </S.ContactItemLink>
                )}

                {data?.informacoes?.[0]?.telefone && (
                  <S.ContactItemLink
                    href={`tel:${data.informacoes[0].telefone.toString().replace(/\D/g, '')}`}
                    title="Ligar para a Copasul"
                  >
                    <LocalPhoneIcon />
                    <span>
                      {data.informacoes[0].telefone
                        .toString()
                        .replace(/^(\d{2})\s*(\d{4,5})-?(\d{4})$/, '($1) $2-$3')}
                    </span>
                  </S.ContactItemLink>
                )}
              </S.ContactList>
            </S.BrandInfoWrapper>

            {data?.redesSociais && data.redesSociais.length > 0 && (
              <S.SocialNetworksBox>
                <S.SocialTitle>Siga nossas redes:</S.SocialTitle>
                <S.SocialNetworks>
                  {data.redesSociais.map((item, index) => {
                    const rede = item?.linkRedeSocial;
                    if (!rede) return null;
                    return (
                      <S.SocialButton
                        key={index}
                        type="button"
                        title={rede?.tituloLink || 'Rede Social'}
                        aria-label={rede?.tituloLink || 'Rede Social'}
                        onClick={() => {
                          if (rede?.linkExterno) {
                            window.open(rede.linkExterno, '_blank', 'noopener,noreferrer');
                          }
                        }}
                      >
                        {rede?.imagemRelacionada?.[0] && (
                          <img
                            src={`${baseUrlImg}${rede.imagemRelacionada[0]}`}
                            alt={rede?.tituloLink || 'Ícone rede social'}
                          />
                        )}
                      </S.SocialButton>
                    );
                  })}
                </S.SocialNetworks>
              </S.SocialNetworksBox>
            )}
          </S.BrandColumn>

          {/* Colunas Dinâmicas de Navegação (Institucional, Nossos Negócios, Comunicação, Contato) */}
          {menu &&
            menu.map((item, index) => {
              const menuObj = item?.menu;
              if (!menuObj) return null;

              const title = menuObj?.tituloMenu;
              const subMenus = menuObj?.subMenu;
              const hasSubMenu = Array.isArray(subMenus) && subMenus.length > 0;
              const directRoute = menuObj?.rota;

              return (
                <S.NavColumn key={index}>
                  {hasSubMenu ? (
                    <S.ColumnTitle>{title}</S.ColumnTitle>
                  ) : directRoute ? (
                    directRoute.startsWith('http') ? (
                      <S.ColumnTitleLink
                        as="a"
                        href={directRoute}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {title}
                      </S.ColumnTitleLink>
                    ) : (
                      <S.ColumnTitleLink to={directRoute}>
                        {title}
                      </S.ColumnTitleLink>
                    )
                  ) : (
                    <S.ColumnTitle>{title}</S.ColumnTitle>
                  )}

                  {hasSubMenu && (
                    <S.NavList>
                      {subMenus.map((subItem, subIndex) => {
                        const subTitle = subItem?.tituloSubmenu;
                        const subRoute = subItem?.rotaSubmenu || '#';
                        const isExternal = subRoute.startsWith('http') || subRoute.startsWith('//');

                        return (
                          <li key={subIndex}>
                            {isExternal ? (
                              <S.NavLink
                                as="a"
                                href={subRoute}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {subTitle}
                              </S.NavLink>
                            ) : (
                              <S.NavLink to={subRoute}>
                                {subTitle}
                              </S.NavLink>
                            )}
                          </li>
                        );
                      })}
                    </S.NavList>
                  )}
                </S.NavColumn>
              );
            })}
        </S.FooterGrid>

        {/* Divisor moderno */}
        <S.FooterDivider />

        {/* Rodapé inferior: Direitos Reservados e Parceiros */}
        <S.FooterBottom>
          <S.CopyrightText>
            {data?.copyright || `© Copasul ${new Date().getFullYear()}. Todos os direitos reservados.`}
          </S.CopyrightText>

          {data?.parceiros && data.parceiros.length > 0 && (
            <S.PartnersBox>
              {data.parceiros.map((item, index) => {
                const parceiro = item?.linkParceiro;
                if (!parceiro) return null;

                return (
                  <S.PartnerButton
                    key={index}
                    type="button"
                    title={parceiro?.tituloLink || 'Parceiro'}
                    aria-label={parceiro?.tituloLink || 'Parceiro'}
                    onClick={() => {
                      if (parceiro?.linkExterno) {
                        window.open(parceiro.linkExterno, '_blank', 'noopener,noreferrer');
                      }
                    }}
                  >
                    {parceiro?.imagemRelacionada?.[0] && (
                      <img
                        src={`${baseUrlImg}${parceiro.imagemRelacionada[0]}`}
                        alt={parceiro?.tituloLink || 'Logo Parceiro'}
                        className="footer-logo"
                      />
                    )}
                  </S.PartnerButton>
                );
              })}
            </S.PartnersBox>
          )}
        </S.FooterBottom>
      </S.FooterContainer>
    </S.FooterBox>
  );
};
